



















import { Component, Vue } from 'vue-property-decorator';

import faqService from '@/services/faq.service';

@Component({})
export default class Faq extends Vue {
  public show = true;

  public answers = [];

  public mounted() {
    this.getFaq();
  }

  public getFaq() {
    faqService.getFaqList().then((response: any) => {
      const data = response.data.data;
      data.forEach((element) => {
        return element.show = false;
      });
      this.answers = data;
    });
  }
}
